import { render, staticRenderFns } from "./url.vue?vue&type=template&id=a3f184d4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f184d4')) {
      api.createRecord('a3f184d4', component.options)
    } else {
      api.reload('a3f184d4', component.options)
    }
    module.hot.accept("./url.vue?vue&type=template&id=a3f184d4&", function () {
      api.rerender('a3f184d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/markdown/url.vue"
export default component.exports